import { SummaryStats as Stats } from "../types";
import { formatCurrency } from "../utils";

const TILES: {
  label: string;
  value: (s: Stats) => React.ReactNode;
  className?: string;
}[] = [
  { label: "Total Clients", value: (s) => s.totalClients },
  { label: "Total Booking Revenue", value: (s) => formatCurrency(s.totalRevenue) },
  {
    label: "Total Commission",
    value: (s) => formatCurrency(s.totalCommission),
    className: "text-green-700",
  },
  { label: "Pending Charges", value: (s) => s.pendingInvoices, className: "text-yellow-600" },
  {
    label: "Awaiting Payment",
    value: (s) => s.awaitingPaymentInvoices,
    className: "text-purple-600",
  },
  { label: "Paid This Month", value: (s) => s.paidInvoices, className: "text-green-600" },
];

export function SummaryStats({ stats }: { stats: Stats }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-4">
      {TILES.map((t) => (
        <div
          key={t.label}
          className="bg-surface-primary rounded-lg p-4 shadow-sm border border-[#E9E9EB]"
        >
          <div className="text-xs text-content-tertiary mb-1">{t.label}</div>
          <div className={`text-2xl font-semibold ${t.className ?? ""}`}>
            {t.value(stats)}
          </div>
        </div>
      ))}
    </div>
  );
}
